/**
 * 장면 전환의 이름 — 플레이리스트 편집기가 고르게 한다. 값의 목록은 코어가 정한다(`TRANSITIONS`).
 */
import { TRANSITIONS, type Transition } from '@signageone/core';

export const TRANSITION_LABELS: Record<Transition, string> = {
  fade: '페이드',
  slide: '밀기',
  'slide-up': '위로 밀기',
  zoom: '확대',
  cover: '덮기',
  flip: '뒤집기',
  tiles: '대각선 타일',
  none: '없음',
};

/**
 * 효과마다 한두 문장 — 미리보기 카드와 선택칸 말풍선에 쓴다. 설명서(`manual/chapters/content.ts` 의 전환 표)와
 * 같은 말이어야 한다 — 한쪽만 고치면 설명서와 화면이 다른 효과를 말한다.
 */
export const TRANSITION_DESCRIPTIONS: Record<Transition, string> = {
  fade: '이전 화면 위로 다음 화면이 서서히 겹쳐 나타납니다. 기본값입니다.',
  slide: '다음 화면이 오른쪽에서 들어오며 이전 화면을 왼쪽으로 밀어냅니다.',
  'slide-up': '다음 화면이 아래에서 올라오며 이전 화면을 위로 밀어냅니다. 세로로 세운 화면에 잘 어울립니다.',
  zoom: '이전 화면이 앞으로 다가오고, 그 위로 다음 화면이 살짝 작은 데서 커지며 겹쳐 나타납니다.',
  cover: '다음 화면이 그림자를 드리운 카드처럼 오른쪽에서 미끄러져 와 덮고, 이전 화면은 살짝 물러나며 어두워집니다.',
  flip: '카드를 뒤집는 것처럼 화면이 세로 축으로 돌아 다음 화면이 나타납니다.',
  tiles: '이전 화면이 작은 칸으로 나뉘어 왼쪽 위부터 대각선을 따라 차례로 사라지며 다음 화면이 드러납니다. 웹 페이지에서 넘어갈 때는 페이드로 바뀝니다.',
  none: '곧바로 바뀝니다.',
};

/** 고르는 순서 — 코어의 목록 순서(자주 쓰는 것 먼저, 없음은 끝). */
export const TRANSITION_OPTIONS: ReadonlyArray<{ value: Transition; label: string }> = TRANSITIONS.map((value) => ({
  value,
  label: TRANSITION_LABELS[value],
}));
